import React from 'react';

import Layout from '@components/layout';
import SEO from '@components/seo';
import Banner from '@components/banner';
import DiscoverProducts from '@components/discoverProducts';
import { CategoryBuilders } from '@constants/app';

import '@styles/styles.scss';

const BuildersPage = ({ data }) => {
  const ctf = data.contentfulDiscoverPages;
  const {
    forBuildersBannerTitle,
    forBuildersBannerSubtitle,
    forBuildersBannerImageTitle,
    forBuildersTitle,
    forBuildersDescription
  } = ctf;
  const assets = data.allContentfulAsset.edges.map(edge => edge.node);

  const tradeUpDescription = ctf.tradeUpDescription.tradeUpDescription;
  const workUpDescription = ctf.workUpDescription.workUpDescription;
  const serviceUpDescription = ctf.serviceUpDescription.serviceUpDescription;
  const projectUpDescription = ctf.projectUpDescription.projectUpDescription;
  const checkUpDescription = ctf.checkUpDescription.checkUpDescription;
  const upFamilyDescription = ctf.upFamilyDescription.upFamilyDescription;

  return (
    <Layout>
      <SEO title="DiscoverBuilders"/>
      <Banner
        assets={assets}
        imageTitle={forBuildersBannerImageTitle}
      >
        <div className="d-flex flex-column mt-3 mb-5 mb-md-0">
          <h1>{forBuildersBannerTitle}</h1>
          <p className="text-muted">{forBuildersBannerSubtitle.forBuildersBannerSubtitle}</p>
        </div>
      </Banner>
      <DiscoverProducts
        productCategory={CategoryBuilders}
        title={forBuildersTitle}
        description={forBuildersDescription.forBuildersDescription}
        tradeUpDescription={tradeUpDescription}
        workUpDescription={workUpDescription}
        serviceUpDescription={serviceUpDescription}
        projectUpDescription={projectUpDescription}
        checkUpDescription={checkUpDescription}
        upFamilyDescription={upFamilyDescription}
      />
    </Layout>
  );
};

export default BuildersPage;

export const pageQuery = graphql`
  query DiscoverBuildersQuery {
    contentfulDiscoverPages {
      forBuildersBannerTitle
      forBuildersBannerSubtitle {
        forBuildersBannerSubtitle
      }
      forBuildersBannerImageTitle
      forBuildersTitle
      forBuildersDescription {
        forBuildersDescription
      }
      tradeUpDescription {
        tradeUpDescription
      }
      workUpDescription {
        workUpDescription
      }
      serviceUpDescription {
        serviceUpDescription
      }
      projectUpDescription {
        projectUpDescription
      }
      checkUpDescription {
        checkUpDescription
      }
      upFamilyDescription {
        upFamilyDescription
      }
    }
    allContentfulAsset {
      edges {
        node {
          title
          file {
            contentType
            url
            fileName
          }
          fixed {
            height
            width
            src
            srcSet
          }
          fluid(maxWidth: 980) {
            ...GatsbyContentfulFluid
          } 
        }
      }
    }
  }
`;
